import request from '@/utils/request'

/**
 * 第一次设置支付密码
 * @param {*} params {payPwd, confirmPwd}
 * @returns 
 */
export function payPwd(params) {
    return request.post("/goods/payPwd", params)
}

/**
* 重置支付密码
* @param {*} params {payPwd, confirmPwd, code}
* @returns 
*/
export function payPwdReset(params) {
    return request.post("/goods/payPwdReset", params)
}